import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'fin-section-review',
  templateUrl: 'section-review.component.html',
  styleUrls: ['section-review.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SectionReviewComponent {
  title = input<string>();

  /**
   * @deprecated Prefer containerSpacing / headerSpacing
   */
  fullWidth = input(false);

  endTitle = input<string>();
  noContent = input(false);
  showPaddingBottom = input<boolean | undefined>(undefined);
  noButton = input(false);
  endTitleClasses = input('');
  showHighlightedContent = input(false);
  roundedBottom = input(true);
  hasBorder = input(true);
  containerSpacing = input<string | string[]>();
  headerSpacing = input<string | string[]>();

  readonly shouldShowSmallPadding = computed(
    () => this.showPaddingBottom() ?? (!this.fullWidth() && !this.noContent())
  );
  readonly containerClasses = computed(() => [...this.borderClasses(), ...this.resolvedContainerSpacing()]);
  readonly headerClasses = computed(() => [
    ...(this.showHighlightedContent() ? ['heather-700-text', 'text-icon-primary'] : ['nordic-blue-900-text']),
    ...this.resolvedHeaderSpacing(),
  ]);

  private borderClasses(): string[] {
    if (!this.hasBorder()) {
      return [];
    }
    return this.roundedBottom()
      ? ['rounded-large', 'border']
      : ['rounded-top-large', 'border-top', 'border-left', 'border-right'];
  }

  private resolvedContainerSpacing(): string[] {
    const containerSpacing = this.containerSpacing();
    if (containerSpacing) {
      return this.toArray(containerSpacing);
    }
    return this.fullWidth() ? ['pr-small-t'] : ['pr-small'];
  }

  private resolvedHeaderSpacing(): string[] {
    const headerSpacing = this.headerSpacing();
    if (headerSpacing) {
      return this.toArray(headerSpacing);
    }

    const classes: string[] = [];
    if (this.fullWidth()) {
      classes.push('pr-small-x');
    }
    if (this.shouldShowSmallPadding()) {
      classes.push('pr-small-b');
    }
    return classes;
  }

  private toArray(value: string | string[]): string[] {
    return Array.isArray(value) ? value : [value];
  }
}
